// extracted by mini-css-extract-plugin
export default {"button":"_2U5KL","collapsed":"_3i44m"};